import { useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import getDecoders from './get-decoders.js';

const useShouldShowContexts = (contexts, keys) => {
	const location = useLocation();
	const decoders = useRef(getDecoders(contexts));
	const showContexts = useMemo(
		() =>
			keys.map(key => {
				const [, decoder] = decoders.current.find(([k]) => k === key);
				return !!decoder(location);
			}),
		[location, keys]
	);
	return showContexts;
};

export default useShouldShowContexts;
